import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterLink, ButtonModule],
  template: `
    <section class="pp-page">
      <div class="pp-page__header">
        <div class="pp-page__titles">
          <h1>Page not found</h1>
          <p class="pp-sub">The page you requested does not exist or was moved.</p>
        </div>
        <div class="pp-page__actions">
          <a routerLink="/app/dashboard" pButton label="Go to Dashboard" class="p-button-rounded"></a>
        </div>
      </div>
    </section>
  `,
})
export class NotFoundComponent {}
